var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"network-topology-node-container",style:(_vm.containerStyle)},[_c('div',{style:(_vm.nodeImageStyle),attrs:{"id":"node-img"}}),_c('a-tooltip',{attrs:{"title":_vm.title,"placement":"bottom"}},[_c('p',{staticClass:"network-topology-node-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }